import { Retailer_Network_User_Role } from '@occc/graphql';

import { MemberEmployeeDetailsTab } from './types';

export const MEMBER_EMPLOYEE_DETAILS_TAB_PARAM = 'employeeTab';
export const MEMBER_EMPLOYEE_DETAILS_TABS: MemberEmployeeDetailsTab[] = [
  'locations',
  'locationGroups',
  'retailerNetworks',
];

export const mapTabLabel: Record<MemberEmployeeDetailsTab, string> = {
  locations: 'All Locations',
  locationGroups: 'Location Groups',
  retailerNetworks: 'Retailer Networks',
};

export const mapRoleTypeToLabel: Record<Retailer_Network_User_Role, string> = {
  [Retailer_Network_User_Role.RetailerNetworkAdmin]: 'Network Admin',
  [Retailer_Network_User_Role.RetailerNetworkUser]: 'Network User',
  [Retailer_Network_User_Role.SiteAdmin]: 'Manager',
  [Retailer_Network_User_Role.SiteUser]: 'Employee',
};
